import { gql } from "@apollo/client";

export const schoolSearch = gql`
  query groupsManagerData($scenarioId: ID!, $filter: AcademicUnitFilterInput!) {
    data(scenarioId: $scenarioId) {
      groupsManagerSchools(filter: $filter) {
        items {
          id
          name
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;
